import { PLATFORMS_CONFIG } from '../configs/constant';

const ConflictResolutionModal = ({ report, onConfirm, onCancel }) => {
    if (!report) return null;

    return (
        // 1. 全屏固定容器，z-index 确保在最顶层
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">

            {/* 2. 背景遮罩：点击遮罩也可以取消 */}
            <div
                className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
                onClick={onCancel}
            />

            {/* 3. 模态框主体：使用 relative 确保在遮罩上方 */}
            <div className="relative w-full max-w-md bg-white rounded-[32px] shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <div className="p-8">
                    <h3 className="text-2xl font-black text-gray-900 mb-2">Publishing Conflicts</h3>
                    <p className="text-sm text-gray-500 mb-8">
                        We found some compatibility issues. Review how we'll optimize your post for each platform.
                    </p>

                    <div className="max-h-[60vh] overflow-y-auto pr-2 space-y-6 custom-scrollbar">
                        {/* 致命冲突列表 */}
                        {report.mustDeselect.length > 0 && (
                            <div>
                                <label className="text-[10px] font-black text-red-500 uppercase tracking-[0.2em] mb-3 block">
                                    Must Deselect (Incompatible)
                                </label>
                                <div className="space-y-2">
                                    {report.mustDeselect.map(acc => (
                                        <div key={acc.id} className="flex items-center justify-between p-3 bg-red-50/50 rounded-2xl border border-red-100/50">
                                            <div className="flex items-center gap-3">
                                                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white ${PLATFORMS_CONFIG[acc.platform]?.color || 'bg-red-500'}`}>
                                                    <i className={`${PLATFORMS_CONFIG[acc.platform]?.icon} text-sm`}></i>
                                                </div>
                                                <div>
                                                    <p className="text-xs font-bold text-gray-900">{acc.name}</p>
                                                    <p className="text-[10px] text-red-500 font-medium">{acc.reason}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* 可调整列表 */}
                        {report.canAutoAdjust.length > 0 && (
                            <div>
                                <label className="text-[10px] font-black text-amber-500 uppercase tracking-[0.2em] mb-3 block">
                                    Will Auto-Adjust (Partial Match)
                                </label>
                                <div className="space-y-2">
                                    {report.canAutoAdjust.map(acc => (
                                        <div key={acc.id} className="flex items-center justify-between p-3 bg-amber-50/50 rounded-2xl border border-amber-100/50">
                                            <div className="flex items-center gap-3">
                                                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white ${PLATFORMS_CONFIG[acc.platform]?.color || 'bg-amber-500'}`}>
                                                    <i className={`${PLATFORMS_CONFIG[acc.platform]?.icon} text-sm`}></i>
                                                </div>
                                                <div>
                                                    <p className="text-xs font-bold text-gray-900">{acc.name}</p>
                                                    <p className="text-[10px] text-amber-600 font-medium">{acc.reason}</p>
                                                </div>
                                            </div>
                                            <i className="fa-solid fa-scissors text-amber-400 text-xs"></i>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* 底部操作区 */}
                    <div className="grid grid-cols-2 gap-4 mt-8">
                        <button
                            onClick={onCancel}
                            className="py-4 px-6 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-2xl font-bold text-sm transition-all active:scale-95"
                        >
                            Back to Edit
                        </button>
                        <button
                            onClick={() => onConfirm('FIX_AND_PUBLISH')}
                            className="py-4 px-6 bg-red-600 hover:bg-red-700 text-white rounded-2xl font-bold text-sm shadow-xl shadow-red-200 transition-all active:scale-95"
                        >
                            Fix & Publish
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConflictResolutionModal;